"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiInputBaseOverrides = function (_a) {
    var typography = _a.typography, spacing = _a.spacing, palette = _a.palette;
    return ({
        root: {
            fontSize: typography.pxToRem(14),
            letterSpacing: "0.014em",
            lineHeight: 1.43,
            "&$disabled": {
                color: undefined,
                opacity: palette.action.disabledOpacity,
            },
        },
        multiline: {
            padding: 0,
        },
        input: {
            boxSizing: "border-box",
            height: spacing(12),
            // Regular without label
            padding: spacing(4),
            // Regular with label
            "label + $formControl > &": {
                paddingTop: spacing(6),
                paddingBottom: spacing(2),
            },
            "&::placeholder": {
                opacity: 0.7,
                color: palette.text.secondary,
                "$disabled&": {
                    color: palette.text.disabled,
                },
            },
        },
        inputMultiline: {
            // Multiline without label
            padding: spacing(3, 4),
            // Multiline with label
            "label + $formControl > &": {
                marginTop: spacing(6),
                padding: spacing(0, 4, 2),
            },
        },
    });
};
//# sourceMappingURL=MuiInputBase.js.map